import React, { FC } from 'react'

import { ContentfulProcessor } from '@smarty-nx/ds'

import classes from './hero.module.scss'
import { ContentfulLink } from '../../../../components/contentful-link'
import { isBanner } from '../../../content-type-checks'

export const HeroSection: FC<
  Queries.GenericPageSectionFragment & { index: number }
> = (section) => {
  const item = section.items && section.items.filter(isBanner)[0]
  const imageUrl = item?.image?.url
  const imageTitle = item?.image?.title || ''

  if (!item) {
    return null
  }

  return (
    <div className={classes.pageBanner}>
      {imageUrl && (
        <img
          className={classes.image}
          src={imageUrl}
          alt={imageTitle}
          loading="lazy"
          decoding="async"
          fetchPriority="high"
        />
      )}
      <div className={classes.pageBannerContent}>
        {section.index === 0 ? (
          <h1 className={classes.title}>{item.title}</h1>
        ) : (
          <h2 className={classes.title}>{item.title}</h2>
        )}
        <ContentfulProcessor
          content={item.description?.internal.content || ''}
          components={{ p: 'p' }}
        />
        <ContentfulLink
          link={item.link?.internal.content || ''}
          className={classes.ctaButton}
        />
      </div>
    </div>
  )
}
